import React from 'react';
import Theme from '@dagensmat/carrot/Theme';
import { Typography } from '@dagensmat/carrot/Components';
import { TypographyNames } from '@dagensmat/carrot/Components/Typography/Typography.types';
import i18n from 'i18n';
import { InputContainer } from '_common/components/input/Input.style';
import { Select } from '../../../carrot/select';

type SelectProps = {
  options: { value: string; name: string }[];
  selectedValue?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  width?: string;
};

type SelectWithLabelProps = {
  labelText: string;
  saved?: boolean;
  savedText?: string | null;
  explanationText?: React.ReactNode;
  labelType?: TypographyNames;
} & SelectProps;

const SelectWithLabel = ({
  labelText,
  saved = false,
  savedText = i18n.t('common:Saved'),
  explanationText,
  labelType = 'inputLabel',
  ...rest
}: SelectWithLabelProps) => {
  return (
    <InputContainer margin={0} marginRight={Theme.Spacings.xs}>
      <Typography variant={labelType} id={labelText} mb="xxs">
        {labelText}
      </Typography>
      <Select {...rest} id={labelText} />
      {explanationText && (
        <Typography variant="paragraphSmall">{explanationText}</Typography>
      )}
      {saved && (
        <Typography
          variant="paragraphSmall"
          mt="xxs"
          style={{ textAlign: 'left' }}
        >
          {savedText}
        </Typography>
      )}
    </InputContainer>
  );
};

export default SelectWithLabel;
